.checkbox-container {
    display: flex;
    align-items: center;
  }
  
  .checkbox-container input[type="checkbox"] {
    margin-right: 8px;
  }